import { useCallback } from 'react';

import qs from 'qs';

import { useCurrentUserId, useSessionUuid } from 'src/app/shared/hooks/session';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import type { CommentShareChannel, PartialComment, PartialPetition } from '../types';

function getCommentUrl({
	sessionUuid,
	currentUserId,
	commentId,
	slug,
	campaign,
	socialNetworkName,
}: {
	sessionUuid: string;
	currentUserId: string | undefined;
	commentId: string;
	slug: string;
	campaign: string;
	socialNetworkName: string;
}) {
	const recruiterTrackParams = !currentUserId ? {} : { recruiter: currentUserId };
	const trackParams = qs.stringify(
		{
			...recruiterTrackParams,
			recruited_by_id: sessionUuid,
			utm_source: 'comment_share',
			utm_campaign: campaign,
			utm_medium: socialNetworkName,
		},
		{ encodeValuesOnly: true },
	);
	return `/p/${slug}/c/${commentId}?${trackParams}`;
}

export function useGetCommentShareUrl(
	comment: PartialComment,
	petition: PartialPetition,
): ShareActionsOptions<CommentShareChannel>['getUrl'] {
	const sessionUuid = useSessionUuid();
	const currentUserId = useCurrentUserId();
	const { slug } = petition;

	return useCallback(
		(channel) => {
			const commentUrlArgs = { sessionUuid, currentUserId, commentId: comment.id, slug };
			switch (channel) {
				case 'facebook':
					return getCommentUrl({ ...commentUrlArgs, socialNetworkName: 'facebook', campaign: 'facebook' });
				case 'twitter':
					return getCommentUrl({
						...commentUrlArgs,
						socialNetworkName: 'twitter',
						campaign: 'share_twitter_responsive',
					});
				default:
					// not supported
					return '';
			}
		},
		[sessionUuid, currentUserId, comment, slug],
	);
}
